import { Box } from "@mui/material";

import { IconButton } from "./IconButton";
import { Text } from "./Text";

export interface DialogHeaderProps {
  /**
   * The title text displayed in the header
   */
  title: string;
  /**
   * Whether to show the close button
   */
  showCloseButton?: boolean;
  /**
   * Callback when close button is clicked
   */
  onClose?: () => void;
}

/**
 * Dialog header component with title and optional close button.
 * Used internally by Dialog component.
 */
export function DialogHeader(props: DialogHeaderProps) {
  const { title, showCloseButton = true, onClose } = props;

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: theme.spacing(5),
        paddingX: theme.spacing(5),
        paddingY: theme.spacing(4),
        borderBottom: `1px solid ${theme.palette.border?.base}`,
        overflow: "hidden",
      })}
    >
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
        }}
      >
        <Text
          bold
          sx={{
            whiteSpace: "normal",
          }}
        >
          {title}
        </Text>
      </Box>

      {showCloseButton && (
        <IconButton
          aria-label="Close dialog"
          iconType="close"
          size="small"
          variant="outlined"
          onClick={onClose}
        />
      )}
    </Box>
  );
}
